export default __webpack_public_path__ + "static/media/black-queen.ae5587cc.png";